import React from 'react';
import { Button } from 'react-bootstrap';
import { Messenger } from 'react-bootstrap-icons';

const FBMessengerContactButton = ({buttonText = "Contact Us on Messenger"}) => {
    
    return <a href="https://m.me/169822776222035" target="_blank">
	    <Button variant="primary" size="sm"><Messenger /> {buttonText}</Button>
	</a>;
};

export default FBMessengerContactButton;




